var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-upload-file',_vm._b({attrs:{"file-list":_vm.fileList,"max-upload-file-limit":_vm.fileNumber || 5,"file-size-limit":_vm.fileSize || 100},on:{"on-change":_vm.handleChange}},'custom-upload-file',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }